import type { CityConfig } from "../city-template/types";

export const lasCrucesConfig: CityConfig = {
  city: "Las Cruces",
  state: "New Mexico",
  stateAbbr: "NM",
  slug: "las-cruces",
  route: "/cities/las-cruces",
  title: "Emergency Passport Las Cruces, NM — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Las Cruces, NM — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving NMSU students, White Sands Missile Range personnel, Organ Mountain families, and southern New Mexico travelers.",
  h1: "Emergency & Expedited Passport Services in Las Cruces, NM",
  heroSubtitle: "NMSU study-abroad program starting in two weeks? Business trip to Mexico across the border? Family vacation booked and your passport is expired? We help Las Cruces residents — from Mesilla Valley families to university students to White Sands personnel — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Breathtaking%20panoramic%20view%20of%20Las%20Cruces%20New%20Mexico%20with%20the%20Organ%20Mountains%20at%20golden%20sunset%2C%20the%20Organ%20Needle%20spires%20rising%20dramatically%20behind%20the%20city%2C%20warm%20desert%20light%20casting%20long%20shadows%20across%20the%20Mesilla%20Valley%2C%20adobe-style%20architecture%20visible%20in%20the%20foreground%2C%20vast%20high%20desert%20landscape%20with%20sagebrush%20and%20yucca%2C%20professional%20travel%20photography%20with%20rich%20warm%20earth%20tones&width=1800&height=700&seq=las-cruces-hero-2026&orientation=landscape",
  heroImageAlt: "Las Cruces New Mexico with Organ Mountains at golden sunset",
  geoPosition: "32.3199;-106.7637",
  geoPlacename: "Las Cruces, New Mexico",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "El Paso Passport Agency",
    address: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
    distance: "Located in downtown El Paso, TX — approximately 45 miles south of Las Cruces. Appointments required, typically booked 2+ weeks out.",
  },
  nearbyCitiesZips: [
    { name: "Las Cruces", zips: "88001, 88003, 88004, 88005, 88007, 88011, 88012" },
    { name: "Mesilla", zips: "88046" },
    { name: "Anthony", zips: "88021" },
    { name: "Sunland Park", zips: "88063" },
    { name: "Hatch", zips: "87937" },
    { name: "Deming", zips: "88030, 88031" },
    { name: "Alamogordo", zips: "88310, 88311" },
    { name: "Truth or Consequences", zips: "87901" },
    { name: "El Paso (closest agency)", zips: "79901–79999" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Southern NM Emergency Processing", desc: "Reserved courier access to the El Paso Passport Agency — as fast as 24 hours for Las Cruces-area travelers with immediate departures." },
    { icon: "ri-graduation-cap-line", title: "NMSU Student & Study Abroad Ready", desc: "New Mexico State University sends students abroad each semester. We help Aggies get passports in time for program orientations and international exchange deadlines." },
    { icon: "ri-flight-takeoff-line", title: "Cross-Border Mexico Travel Expertise", desc: "Las Cruces is minutes from Mexico. We understand the unique timing challenges of cross-border travel, family visits, and medical tourism to Ciudad Juarez." },
    { icon: "ri-shield-line", title: "White Sands Missile Range Support", desc: "We serve WSMR civilian personnel, contractors, and military families with expedited passport processing for official travel and PCS moves." },
  ],
  internalLinks: [
    { name: "Fast passport services in Albuquerque, NM", route: "/cities/albuquerque" },
    { name: "Expedited passport in Santa Fe, NM", route: "/santa-fe" },
    { name: "Urgent passport services in El Paso, TX", route: "/cities/el-paso" },
    { name: "New Mexico passport services overview", route: "/states/new-mexico" },
  ],
  fpcOfficeAddress: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
  fpcOfficeNote: "Fast Passport Center serves Las Cruces via secure registered courier with direct access to the El Paso Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Las Cruces residents can ship from any UPS Store, FedEx Office, or post office location across the Mesilla Valley.",
  fpcOfficeDistance: "Serving Las Cruces, Mesilla, Anthony, Sunland Park, Hatch, Deming, Alamogordo, and all Doña Ana County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Las Cruces and the greater Mesilla Valley. From the NMSU campus area to historic Old Mesilla, from the East Mesa to the Sonoma Ranch corridor — we serve all of Doña Ana County. Our courier service eliminates the need to drive to El Paso and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Las Cruces and all southern New Mexico communities including Mesilla, Anthony, Sunland Park, Hatch, Deming, Alamogordo, and Truth or Consequences. We also serve travelers departing from El Paso International Airport who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Las Cruces as simple as possible — with the efficiency and reliability NMSU students, Mesilla Valley families, and WSMR personnel need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Las Cruces travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Las Cruces travelers encounter unique passport issues — everything from cross-border Mexico travel documentation to study-abroad timing crunches for NMSU students. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Las Cruces travelers — from NMSU Aggies to Organ Mountain families to Mesilla Valley professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Las Cruces, NM? Here are the most common ones we hear from Mesilla Valley-area travelers.",
  statePageRoute: "/states/new-mexico",
  statePageName: "New Mexico",
  servicesIntro: "Whether you need a renewal before a flight from El Paso, an emergency passport for a last-minute Mexico trip, or a first-time passport for an NMSU study-abroad program — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.donaanacounty.org/departments/assessor/motor-vehicle",
  dmvLabel: "Doña Ana County Motor Vehicle Division — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Mexico border crossing in two days? NMSU orientation abroad starting this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Las Cruces-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Las Cruces residents renew fast — no agency visit required for most renewals. Perfect for Mesilla Valley professionals and NMSU faculty preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Las Cruces residents through every step — from NMSU campus to Old Mesilla — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your cross-border trip or study-abroad departure is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family vacation or Mesilla Valley family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for southern NM residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent travel? Ideal for WSMR contractors, NMSU researchers, and southern NM professionals who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Mesilla Valley travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Las Cruces NM", description: "Urgent passport processing for Las Cruces New Mexico travelers with immediate departure needs from El Paso Airport." },
    { name: "Expedited Passport Renewal Las Cruces NM", description: "Fast passport renewal for Las Cruces New Mexico residents with a previously-issued passport." },
    { name: "First-Time Passport Las Cruces NM", description: "New passport application services for Las Cruces New Mexico residents applying for their first passport." },
    { name: "Child Passport Las Cruces NM", description: "Minor passport services for Las Cruces New Mexico families with children under 16." },
    { name: "Name Change Passport Las Cruces NM", description: "Passport name correction after marriage, divorce, or legal name changes for Las Cruces residents." },
    { name: "Second Passport Las Cruces NM", description: "Second passport services for southern NM contractors and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Marco R.",
      location: "Las Cruces",
      rating: 5,
      text: "I'm an NMSU grad student and my study-abroad program in Spain was starting in 6 days. My passport had expired and I panicked. Fast Passport Center got it back in 3 days. The document review caught an error on my DS-11 that would have caused a rejection.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Martinez Family",
      location: "Mesilla",
      rating: 5,
      text: "We planned to visit family in Chihuahua for the holidays and realized our kids' passports expired. They walked us through the child passport process step by step. Passports arrived in 5 days. We were so relieved.",
      service: "Child Passport Renewal",
    },
    {
      name: "David K.",
      location: "Las Cruces (WSMR)",
      rating: 5,
      text: "I'm a contractor at White Sands and needed urgent passport renewal for a conference in Germany. They handled everything remotely — I shipped documents overnight and had my new passport before my departure date.",
      service: "Passport Renewal",
    },
    {
      name: "Ana S.",
      location: "Las Cruces",
      rating: 5,
      text: "I needed a name change on my passport after getting married. They caught a documentation issue I never would have noticed and got my new passport back in 7 days. Professional and thorough.",
      service: "Name Change Passport",
    },
  ],
  facilities: [
    {
      id: "lc-1",
      name: "Las Cruces Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E Las Cruces Ave",
      city: "Las Cruces",
      state: "NM",
      zip: "88001",
      phone: "(575) 524-2841",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Las Cruces",
      website: "https://tools.usps.com/find-location.htm?location=1376537",
      websiteLabel: "USPS Location",
      notes: "Main passport acceptance facility in Las Cruces. Photo services on-site. Serves downtown and the NMSU campus area. Appointment strongly recommended — walk-in availability is limited.",
      icon: "ri-mail-line",
    },
    {
      id: "lc-2",
      name: "Mesilla Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3368 N Main St",
      city: "Las Cruces",
      state: "NM",
      zip: "88012",
      phone: "(575) 373-7722",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "North Las Cruces / Mesilla Park",
      website: "https://tools.usps.com/find-location.htm?location=1367624",
      websiteLabel: "USPS Location",
      notes: "Convenient for residents in North Las Cruces and the Mesilla Park area. Photo services available. Less busy than the downtown location — shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "lc-3",
      name: "Doña Ana County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "845 N Motel Blvd",
      city: "Las Cruces",
      state: "NM",
      zip: "88007",
      phone: "(575) 647-7421",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      distance: "Las Cruces — Doña Ana County",
      website: "https://www.donaanacounty.org/departments/county-clerk",
      websiteLabel: "Doña Ana County Clerk",
      notes: "Official county clerk passport acceptance facility. Serves entire Doña Ana County. No photo services on-site — bring completed passport photos. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "lc-4",
      name: "Anthony Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1055 E Ohara Rd",
      city: "Anthony",
      state: "NM",
      zip: "88021",
      phone: "(575) 882-3777",
      hours: "Mon–Fri 9:00 AM – 3:00 PM",
      distance: "Anthony — southern Doña Ana County",
      website: "https://tools.usps.com/find-location.htm?location=1374014",
      websiteLabel: "USPS Location",
      notes: "Serves Anthony, Sunland Park, and southern Doña Ana County. Smaller facility with limited hours — call ahead to confirm availability and appointments.",
      icon: "ri-mail-line",
    },
    {
      id: "lc-5",
      name: "El Paso Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8401 Boeing Dr",
      city: "El Paso",
      state: "TX",
      zip: "79910",
      phone: "(915) 780-7555",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "El Paso — near airport",
      website: "https://tools.usps.com/find-location.htm?location=1376517",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility near Las Cruces. Convenient for travelers already heading to El Paso Airport. Full photo services available. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "lc-6",
      name: "Deming Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 W Spruce St",
      city: "Deming",
      state: "NM",
      zip: "88030",
      phone: "(575) 546-2221",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Deming — Luna County",
      website: "https://tools.usps.com/find-location.htm?location=1367462",
      websiteLabel: "USPS Location",
      notes: "Serves Deming, Luna County, and surrounding communities west of Las Cruces. Photo services available. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to El Paso Passport Agency (45 miles)", fpc: "Most Las Cruces travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "NM-Specific Guidance", agency: "Generic — no NMSU, WSMR, or border-crossing expertise", fpc: "Full NMSU/WSMR/southern NM knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming El Paso Agency Takes Walk-Ins",
      description: "The El Paso Passport Agency requires appointments even for emergencies. Many Las Cruces residents drive 45 minutes only to be turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Las Cruces applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Cross-Border Travel Without Passport Card",
      description: "Many Mesilla Valley residents assume a driver's license works for Mexico travel. It does not. We help you get the correct passport documentation for cross-border trips.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Southern NM families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "NMSU Study-Abroad Deadline Crunch",
      description: "NMSU students often wait until the last month before orientation to apply. A single error can delay processing by weeks. We provide a student-specific accelerated checklist.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or NMSU dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Las Cruces clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to El Paso or wait at the passport agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Las Cruces?", a: "We offer Las Cruces-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Las Cruces?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Las Cruces post office or the Doña Ana County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Las Cruces address." },
    { q: "Where can I get passport acceptance in Las Cruces?", a: "Las Cruces has acceptance facilities at the Main Post Office (downtown), Mesilla Park Post Office, and the Doña Ana County Clerk office. We maintain an updated list of facilities with hours, photo availability, and appointment options." },
    { q: "Does the El Paso Passport Agency handle walk-ins?", a: "The El Paso Passport Agency (located 45 miles south in El Paso) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without agency restrictions." },
    { q: "Can you help NMSU students with study-abroad passports?", a: "Yes. We regularly assist NMSU Aggies with expedited passports for semester exchange, summer programs, and faculty-led trips. We understand the acceptance-to-orientation timeline and have a student-specific checklist to keep everything on track." },
    { q: "What documents do Las Cruces applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Las Cruces-specific checklist." },
    { q: "Can I use the same passport for Mexico and other countries?", a: "Yes. A standard U.S. passport book is valid for Mexico and all international air travel. If you primarily travel by land to Mexico, a passport card is also an option. We can help you decide which is right for your travel needs." },
    { q: "How do I check my passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Las Cruces to final return shipping typically matches your chosen speed tier." },
    { q: "Is there a passport agency in Las Cruces?", a: "No. The closest passport agency is the El Paso Passport Agency at 700 E San Antonio Ave, El Paso, TX. However, it only serves travelers with life-or-death emergencies. For standard expedited needs — even urgent ones — our courier channel is faster and more accessible than agency appointments." },
    { q: "Can you help with passports for El Paso Airport departures?", a: "Yes. El Paso International Airport is the primary hub for southern NM international travel, and we regularly assist Las Cruces travelers with expedited passports for international departures from ELP. We coordinate timelines around your departure from the Mesilla Valley." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Las Cruces Residents",
    intro: "Las Cruces' unique position at the crossroads of southern New Mexico, West Texas, and the Mexico border creates distinct passport timing challenges. Here's what Las Cruces travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "ELP — El Paso International Airport",
        subtitle: "Closest international airport to Las Cruces, ~50 miles south",
        description: "ELP serves the entire Borderland region with flights to Dallas, Houston, Phoenix, Denver, and Los Angeles — major international connecting hubs. For Las Cruces residents, ELP is the primary gateway for international travel. The 50-mile drive is straightforward down I-10, but passport urgencies often surface 48–72 hours before departure when travelers realize their documents are not in order.",
        tip: "ELP-to-DFW or ELP-to-IAH connections are the most common routes for Las Cruces international travelers. Check your passport validity when you book, not when you pack for the drive to El Paso.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ABQ — Albuquerque International Sunport",
        subtitle: "Largest NM airport, ~225 miles north of Las Cruces",
        description: "For direct international flights and more carrier options, some Las Cruces travelers drive to ABQ. The three-hour drive means passport issues must be resolved well before departure. ABQ offers direct flights to Mexico and more domestic connections than ELP. Las Cruces residents often use ABQ for Asia and Europe connections via DFW, LAX, or DEN.",
        tip: "If driving to ABQ for an international flight, you need your passport in hand before leaving Las Cruces. There are no passport services at ABQ that can process same-day applications.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "NMSU Study Abroad & Student Travel",
        subtitle: "New Mexico State University, Doña Ana Community College",
        description: "NMSU sends hundreds of students abroad each year through the Office of Education Abroad. Programs span Mexico, Central America, Europe, and Asia. Many first-generation college students at NMSU have never held a passport. The tight window between acceptance and program orientation — often 4–8 weeks — puts pressure on standard passport processing timelines. DACC students in nursing, agriculture, and international programs also need expedited service.",
        tip: "First-time applicants must visit an acceptance facility. We guide NMSU students to the nearest facility with the earliest available appointment — the Main Post Office on Las Cruces Ave is the most common choice, just blocks from campus.",
      },
      {
        icon: "ri-shield-line",
        title: "White Sands Missile Range & Military Travel",
        subtitle: "WSMR civilian contractors and military personnel",
        description: "White Sands Missile Range is the largest military installation in the United States by area and employs thousands of civilians and contractors. International travel for testing programs, joint exercises, and contractor meetings in allied nations creates regular passport urgencies. Official travel often requires expedited processing, and the nearest military passport office is in El Paso at Fort Bliss.",
        tip: "Civilian contractors at WSMR traveling on official orders may qualify for no-fee passports. We can help you determine which passport type you need and process both official and tourist passports.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Las Cruces & Cross-Border Mexico Travel",
      description: "Las Cruces sits just 40 miles from the U.S.-Mexico border at Santa Teresa. Many Mesilla Valley residents have deep family ties to Chihuahua and regularly cross the border for family visits, medical appointments, and shopping. A valid passport — not just a driver's license — is required for all border crossings. We help extended families get passports efficiently, especially when multiple family members need documents at the same time.",
    },
  },
  destinations: {
    title: "Where Las Cruces Travelers Go — And Why Passports Get Urgent",
    intro: "Southern New Mexico's unique position creates travel patterns distinct from the rest of the state. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "38%", label: "of Las Cruces expedited requests are Mexico border travel or family visits" },
      { stat: "2–3 Weeks", label: "average lead time Las Cruces travelers have from trip booking to departure" },
      { stat: "May–Aug", label: "peak season when NMSU study-abroad, summer family travel, and WSMR exercises overlap" },
      { stat: "48 Hours", label: "shortest turnaround we have accommodated for a Las Cruces family traveling to Chihuahua" },
    ],
    destinations: [
      { name: "Mexico", context: "Family heritage trips to Chihuahua, Ciudad Juarez border crossings, Cancun resorts, medical tourism", urgency: "Holiday and summer family visits create regular spikes", icon: "ri-map-pin-2-line" },
      { name: "Spain & Latin America", context: "NMSU study-abroad programs in Spanish-speaking countries, faculty research exchanges", urgency: "Program orientation dates are fixed and unmovable", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "WSMR joint training exercises, Alberta energy sector contractor meetings, Vancouver connections", urgency: "Military and contractor travel often has short-notice requirements", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Germany", context: "WSMR allied nation coordination, DoD contractor meetings, NMSU faculty conferences", urgency: "International defense collaboration travel has fixed coordination dates", icon: "ri-map-pin-2-line" },
      { name: "Caribbean", context: "Cruise departures from Galveston, family resort vacations, spring break travel", urgency: "Last-minute cruise deals create 2–3 week urgencies", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "WSMR technology exchanges, NMSU engineering research partnerships, DACC programs", urgency: "International research collaboration has rigid scheduling requirements", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New Mexico Service Areas",
    crossLinksDesc: "We serve travelers across the Land of Enchantment with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Albuquerque", route: "/cities/albuquerque" },
      { name: "Santa Fe", route: "/santa-fe" },
      { name: "El Paso (closest agency)", route: "/cities/el-paso" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Las Cruces", address: "2701 N Main St, Las Cruces, NM 88001", hours: "Daily 8 AM – 10 PM" },
    { name: "Walgreens — East Lohman", address: "3496 E Lohman Ave, Las Cruces, NM 88011", hours: "Daily 8 AM – 10 PM" },
    { name: "Walmart — Valley Drive", address: "571 Walton Blvd, Las Cruces, NM 88001", hours: "Daily 6 AM – 11 PM" },
    { name: "The UPS Store — Telshor", address: "2808 N Telshor Blvd, Las Cruces, NM 88011", hours: "Call for hours" },
    { name: "FedEx Office — Las Cruces", address: "1600 S Valley Dr, Las Cruces, NM 88005", hours: "Call for hours" },
    { name: "Walgreens — North Main", address: "2180 N Main St, Las Cruces, NM 88001", hours: "Daily 8 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Doña Ana County MVD — Las Cruces",
      address: "505 S Main St, Las Cruces, NM 88001",
      hours: "Mon–Fri, 8:00 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "New Mexico MVD — Las Cruces East",
      address: "2100 S Triviz Dr, Las Cruces, NM 88001",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full-service MVD office. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ELP",
      name: "El Paso International Airport",
      distance: "About 50 miles south of Las Cruces",
      address: "6701 Convair Rd, El Paso, TX 79925",
      note: "Closest international airport to Las Cruces. Serves the Borderland region with connections to DFW, IAH, PHX, DEN, and LAX for international gateways.",
      flightUrl: "https://www.elpasointernationalairport.com/",
      flightLabel: "ELP Airport Website",
      featured: true,
    },
    {
      code: "ABQ",
      name: "Albuquerque International Sunport",
      distance: "About 225 miles north of Las Cruces",
      address: "2200 Sunport Blvd, Albuquerque, NM 87106",
      note: "New Mexico's largest airport. Direct international flights to Mexico and extensive domestic connections for international gateways via DFW, LAX, DEN, and PHX.",
      flightUrl: "https://www.abqsunport.com/",
      flightLabel: "ABQ Airport Website",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New Mexico Department of Health. Online, mail, or in-person options available for Doña Ana County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NM Department of Health Vital Records. Required for estate and legal matters in Doña Ana County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Doña Ana County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.donaanacounty.org/departments/county-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Third Judicial District Court. Required for name change passport corrections.",
      url: "https://thirddistrictcourt.nmcourts.gov/",
    },
  ],
};